import * as React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { RadioButton, Image } from "@lululemon/ecom-pattern-library";
import {
  DEVICES,
  getDeviceBreakpoint,
} from "@lululemon/ecom-common/src/lib/breakpoints";

import styles from "./RadioButtonTile.module.scss";

const RADIO_BUTTON_TILE_MAX_WIDTH = 920;
const RadioButtonTile = ({
  className,
  image,
  imageAlt,
  index,
  isEmbedded,
  isSelectedAnswer,
  liveRegion,
  onKeyDown,
  onSelect,
  optionRef,
  prefix,
  radioGroupLength,
  tabIndex,
  text,
  fieldValidationError,
  value,
  questionID,
}) => {
  const boldFirstWord = (text) => {
    const firstWord = text.split(/[-.]/)?.[0];
    const boldFirstWord = (
      <span className="lll-font-weight-semibold">{firstWord}</span>
    );
    const restTest = text.slice(firstWord.length);
    return (
      <>
        {boldFirstWord}
        {restTest}
      </>
    );
  };

  return (
    <div
      ref={optionRef}
      role="radio"
      type="radio"
      aria-checked={isSelectedAnswer}
      aria-controls={liveRegion}
      value={value}
      tabIndex={tabIndex}
      onClick={() => onSelect(index)}
      onKeyDown={(e) => onKeyDown(e, index, radioGroupLength)}
      onMouseDown={(e) => e.preventDefault()}
      className={classNames(styles.radioButtonTile, className, {
        [styles.tileRequiredA11yImprovements]:
          fieldValidationError && !isEmbedded,
      })}
    >
      <Image
        src={image}
        prefix={prefix}
        maxWidth={RADIO_BUTTON_TILE_MAX_WIDTH}
        alt={imageAlt}
        className={styles.radioButtonTileImage}
        lazy={!isEmbedded && getDeviceBreakpoint() === DEVICES.desktop}
      />
      <span
        className={classNames(styles.radioButtonTileText, {
          [styles.radioButtonTileTextEmbedded]: isEmbedded,
          [styles.tileA11yImprovements]: !isEmbedded,
        })}
      >
        {!isEmbedded ? (
          <>
            <RadioButton
              id={`${questionID}-radio-button-${index}`}
              tabIndex="-1"
              checked={isSelectedAnswer}
              classes={{
                icon: styles.tileA11yImprovementsIcon,
                labelContent: styles.tileA11yImprovementsLabel,
              }}
            />
            <span>{boldFirstWord(text)}</span>
          </>
        ) : (
          text
        )}
      </span>
    </div>
  );
};

export default RadioButtonTile;

RadioButtonTile.defaultProps = {
  fieldValidationError: false,
  isEmbedded: false,
};

RadioButtonTile.propTypes = {
  index: PropTypes.number.isRequired,
  isSelectedAnswer: PropTypes.bool.isRequired,
  isEmbedded: PropTypes.bool,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  className: PropTypes.string,
  liveRegion: PropTypes.string.isRequired,
  radioGroupLength: PropTypes.number.isRequired,
  optionRef: PropTypes.oneOfType([
    PropTypes.shape({
      current: PropTypes.instanceOf(PropTypes.Element),
    }),
    PropTypes.func,
  ]).isRequired,
  tabIndex: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  prefix: PropTypes.string,
  fieldValidationError: PropTypes.bool,
  questionID: PropTypes.string.isRequired,
};
